import { RouteConfig } from "vue-router"
import LocationView from "@/views/location/Location.vue"

export const locationRoutes: RouteConfig[] = [
    {
        path: "locations/:locationId",
        component: LocationView,
        meta: { title: "Location", type: "location", maintainsContext: false },
        children: [
            {
                path: "",
                name: "LocationAnimation",
                component: () => import("@/views/location/LocationOverview.vue"),
                meta: { type: "location", maintainsContext: false },
            },
            {
                path: "reports",
                component: () => import("@/layouts/Wrapper.vue"),
                meta: { title: "Reports", maintainsContext: false },
                children: [
                    {
                        path: "",
                        name: "LocationReports",
                        component: () => import("@/views/Report.vue"),
                        meta: { title: "Reports", maintainsContext: false },
                    },
                ],
            },
            {
                path: "manage",
                component: () => import("@/layouts/Wrapper.vue"),
                meta: {
                    title: "Manage Location",
                    type: "manage-location",
                    maintainsContext: false,
                },
                children: [
                    {
                        path: "",
                        name: "ManageLocation",
                        component: () => import("@/views/settings/ManageLocation.vue"),
                        meta: {
                            title: "Manage Location",
                            type: "manage-location",
                            maintainsContext: false,
                        },
                    },
                    {
                        path: "settings",
                        name: "LocationSettings",
                        component: () => import("@/views/location/LocationSettings.vue"),
                        meta: {
                            title: "Settings",
                            type: "location-settings",
                            maintainsContext: false,
                        },
                    },
                    {
                        path: "users",
                        name: "LocationUsers",
                        component: () => import("@/views/settings/Users.vue"),
                        meta: { title: "Users", type: "location-users", maintainsContext: false },
                    },
                    {
                        path: "structure",
                        name: "LocationStructure",
                        component: () => import("@/views/settings/LocationEdit.vue"),
                        meta: {
                            title: "Structure",
                            type: "location-structure",
                            maintainsContext: false,
                        },
                    },
                    {
                        path: "oem-devices",
                        meta: { title: "Devices", maintainsContext: false },
                        component: () => import("@/layouts/Wrapper.vue"),
                        children: [
                            {
                                path: "",
                                name: "LocationDevices",
                                component: () => import("@/views/settings/OEMDevices.vue"),
                                meta: {
                                    title: "Devices",
                                    type: "location-controllers",
                                    maintainsContext: false,
                                },
                            },
                            {
                                path: ":oemDeviceId",
                                name: "LocationOEMDevice",
                                component: () =>
                                    import("@/views/settings/oem-device/OEMDevice.vue"),
                                meta: { title: "Device", maintainsContext: false },
                            },
                            {
                                path: ":oemDeviceId/devices/:deviceId",
                                name: "OEMDeviceDevice",
                                component: () => import("@/views/settings/Device.vue"),
                                meta: { title: "Device Settings", maintainsContext: false },
                            },
                        ],
                    },
                    {
                        path: "pricing",
                        component: () => import("@/layouts/Wrapper.vue"),
                        meta: {
                            title: "Utility rate plans",
                            maintainsContext: false,
                        },
                        children: [
                            {
                                path: "",
                                name: "LocationGroupPricing",
                                component: () => import("@/views/UtilityRatePlan.vue"),
                                meta: {
                                    title: "Utility Rate Plan",
                                    type: "location-utility-plan",
                                    maintainsContext: false,
                                },
                            },
                            {
                                path: "price-lists",
                                component: () => import("@/layouts/Wrapper.vue"),
                                meta: {
                                    title: "Price lists",
                                    type: "location-price-lists",
                                    maintainsContext: false,
                                },
                                children: [
                                    {
                                        path: "",
                                        name: "LocationGroupPriceLists",
                                        component: () =>
                                            import("@/views/pricing/EnergyPricing.vue"),
                                        meta: {
                                            type: "location-price-lists",
                                            maintainsContext: false,
                                        },
                                    },
                                    {
                                        path: "create",
                                        name: "LocationGroupCreatePriceList",
                                        component: () =>
                                            import("@/views/pricing/PriceListView.vue"),
                                        meta: {
                                            title: "Create pricing plan",
                                            type: "location-price-lists-create",
                                            maintainsContext: false,
                                        },
                                    },
                                    {
                                        path: ":priceListId",
                                        name: "LocationGroupEditPriceList",
                                        component: () =>
                                            import("@/views/pricing/PriceListView.vue"),
                                        meta: {
                                            title: "Edit pricing plan",
                                            useTitle: true,
                                            maintainsContext: false,
                                        },
                                    },
                                ],
                            },
                            {
                                path: "plans",
                                component: () => import("@/layouts/Wrapper.vue"),
                                meta: { title: "Time of Use Plan", type: "location-time-plans" },
                                children: [
                                    {
                                        path: "",
                                        name: "LocationGroupPricingPlans",
                                        component: () =>
                                            import("@/views/pricing/UtilityAndNetworkPlans.vue"),
                                        meta: {
                                            title: "Time of Use Plan",
                                            type: "location-time-plans",
                                            maintainsContext: false,
                                        },
                                    },
                                    {
                                        path: "create",
                                        name: "LocationGroupCreatePricingPlan",
                                        component: () =>
                                            import("@/views/pricing/PricingPlanView.vue"),
                                        meta: {
                                            title: "Create utility plan",
                                            type: "location-price-lists-create",
                                            maintainsContext: false,
                                        },
                                    },
                                    {
                                        path: ":planId",
                                        name: "LocationGroupEditPricingPlan",
                                        component: () =>
                                            import("@/views/pricing/PricingPlanView.vue"),
                                        meta: {
                                            title: "Edit utility plan",
                                            useTitle: true,
                                            maintainsContext: false,
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: "spot-market",
                        name: "LocationGroupSpotMarket",
                        component: () => import("@/views/pricing/SpotMarketView.vue"),
                        meta: {
                            title: "Energy Market Prices",
                            type: "location-spot-market",
                            maintainsContext: false,
                        },
                    },
                ],
            },
            {
                path: "charts",
                name: "LocationCharts",
                component: () => import("@/views/location/LocationChart.vue"),
                meta: {
                    title: "Categories chart",
                    type: "location-charts",
                    maintainsContext: false,
                },
            },
            {
                path: "category/:categoryId",
                name: "LocationCategory",
                component: () => import("@/views/location/LocationCategory.vue"),
                meta: { title: "Category info", useTitle: true, maintainsContext: false },
            },
            {
                path: "strategies",
                name: "LocationStrategies",
                component: () => import("@/views/location/LocationStrategies.vue"),
                meta: { title: "Strategies", type: "location-strategies", maintainsContext: false },
            },
            {
                path: "strategies/:strategyId",
                name: "LocationStrategy",
                component: () => import("@/views/settings/oem-device/Strategy.vue"),
                meta: { title: "Strategy", useTitle: true, maintainsContext: false },
            },
            {
                path: "ev-charging",
                name: "LocationEvChargingSessions",
                component: () =>
                    import("@/views/location/ev-charging/EvChargingSessions.vue"),
                meta: { title: "EV Charging Sessions", type: "ev-charging", maintainsContext: false },
            },
            {
                path: "alarm-settings",
                name: "LocationAlarmSettings",
                component: () => import("@/views/location/LocationAlarmSettings.vue"),
                meta: {
                    title: "Alarm settings",
                    type: "location-alarm-settings",
                    maintainsContext: false,
                },
            },
            {
                path: "summary",
                name: "LocationSummary",
                component: () => import("@/views/location/LocationSummary.vue"),
                meta: { title: "Summary", maintainsContext: false },
            },
            {
                path: "flexibility",
                name: "LocationFlexibility",
                component: () => import("@/views/location-groups/LocationGroupHeaderView.vue"),
                meta: { title: "Flexibility", maintainsContext: false },
            },
            {
                path: "device-groups/:deviceGroupId",
                component: () => import("@/views/location/group/Group.vue"),
                meta: { type: "device-group", maintainsContext: false },
                children: [
                    {
                        path: "",
                        name: "MainLocationDeviceGroup",
                        component: () => import("@/views/location/group/GroupOverview.vue"),
                        meta: {
                            title: "Group overview",
                            type: "device-group",
                            maintainsContext: false,
                        },
                    },
                    {
                        path: "devices/:did",
                        name: "MainLocationDevice",
                        component: () => import("@/views/location/device/Device.vue"),
                        meta: { title: "Device", type: "device", maintainsContext: false },
                    },
                ],
            },
        ],
    },
]
